<template>
  <div>
    <h1>Associar Rota</h1>

    <div
      class="container-dados-usuario"
      v-if="
        (!loadingUsuario && listaDadosAssociados.length) ||
        listaDadosDisponiveis.length
      "
    >
      <h5>
        Perfil: <small> {{ usuarioPerfil.perfil }}</small>
      </h5>
      <!-- <h5>Login: <small> {{ usuarioPerfil.login }}</small></h5> -->
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Rotas"
      tituloDisponiveis="Rotas"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="perfisParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PerfilRotaAssociacaoPage",

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: [],
    };
  },

  async created() {
    await this.listarPerfis();
    await this.recuperarPerfilComRotas(this.$route.params.usuario);

    this.atualizarListaDeDadosAssociadosENaoAssociados();
  },

  computed: {
    ...mapGetters("perfisRotas", [
      "loadingUsuario",
      "listaPerfis",
      "perfilSelecionadoComRotas",
    ]),

    usuarioPerfil() {
      return this.perfilSelecionadoComRotas;
    },

    perfisAssociados() {
      return this.perfilSelecionadoComRotas.acl_rotas.map((rota) => {
        return {
          id: rota.id,
          descricao: rota.rota,
          selecionado: false,
        };
      });
    },

    perfisDisponiveis() {
      const listaDePerfisAssociados =
        this.perfilSelecionadoComRotas.acl_rotas.map((rota) => rota.id);
      console.log("perfis", this.listaPerfis);
      return this.listaPerfis
        .filter((rota) => {
          return !listaDePerfisAssociados.includes(rota.id);
        })
        .map((rota) => {
          return {
            id: rota.id,
            descricao: rota.rota,
            selecionado: false,
          };
        });
    },

    colunas() {
      return [
        {
          key: "perfil",
          label: "Nome",
          sortable: false,
        },
        {
          key: "redirecionar",
          label: "Rotas",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    ...mapActions("perfis", ["listarUsuarios", "recuperarUsuario"]),
    ...mapActions("perfisRotas", [
      "listarPerfis",
      "recuperarPerfilComRotas",
      "associarRotaAoPerfil",
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.perfisAssociados;
      this.listaDadosDisponiveis = this.perfisDisponiveis;
    },

    perfisParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map((rota) => {
        return rota.id;
      });

      const payload = {
        perfilId: this.$route.params.usuario,
        rotas: listaIdsAssociados,
      };

      this.associarRotaAoPerfil(payload);
    },
  },
};
</script>

